import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=aeb0496a&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=aeb0496a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb0496a",
  null
  
)

export default component.exports